import RichText from 'Feature/PageContent/Shared/Tiles/RichText';
import { useUserData } from 'Foundation/User/UserContext';
import { FunctionComponent, useMemo } from 'react';
import NavSection from './NavSection';

const NavColumn: FunctionComponent<IReactNavColumn> = (props: IReactNavColumn) => {
  const { userData } = useUserData();
  const navSections = props?.Sections ?? [];
  const richTexts = props?.RichTexts ?? [];
  const isRichTextColumn = richTexts.length > 0;

  const filteredRichText = useMemo(() => {
    if (!userData || richTexts.length === 0) {
      return undefined;
    }
    return richTexts.find((x) => (x.IncludedStates ? x.IncludedStates.includes(userData.state) : true));
  }, [richTexts, userData?.state]);

  const filteredNavSections = useMemo(() => {
    if (!userData || navSections.length === 0) {
      return navSections;
    }
    return navSections.filter((x) => (x.IncludedStates ? x.IncludedStates.includes(userData.state) : true));
  }, [navSections, userData?.state]);

  if (props) {
    return (
      <>
        {isRichTextColumn
          ? filteredRichText && (
              <div className="nav-column-rich-text">
                <RichText content={filteredRichText.RichText}></RichText>
              </div>
            )
          : filteredNavSections &&
            filteredNavSections.length > 0 && (
              <div className="nav-column">
                {filteredNavSections?.map((section: IReactNavSection, index: number) => (
                  <NavSection
                    key={`${section.Title ?? section.Link?.Text ?? 'nav-section'}-${index}`}
                    Link={section.Link}
                    Links={section.Links}
                    Title={section.Title}
                    IncludedStates={section.IncludedStates}
                  />
                ))}
              </div>
            )}
      </>
    );
  } else {
    return <></>;
  }
};
export default NavColumn;
